import clsx from 'clsx'
import { getPoolTier, isPoolTierId } from '@/data/sizeCatalog'
import { isTShirtSize, type ProductSize } from '@/types'
import styles from './SizeBadge.module.css'

interface SizeBadgeProps {
  size: ProductSize
  className?: string
}

/** A product's size: S, M, L or XL, or for a product line (Traverse, Process Pro) the name of its RDS pool tier ("Premium"). */
export function SizeBadge({ size, className }: SizeBadgeProps) {
  if (isPoolTierId(size)) {
    return <span className={clsx(styles.badge, styles.tier, className)} title={getPoolTier(size).label}>{getPoolTier(size).shortLabel}</span>
  }
  const variantClass = isTShirtSize(size)
    ? {
        S: styles.small,
        M: styles.medium,
        L: styles.large,
        XL: styles.xlarge,
      }[size]
    : undefined

  return (
    <span className={clsx(styles.badge, variantClass, className)}>
      {size}
    </span>
  )
}
